import React from 'react'
import { Sun, Moon, Monitor } from 'lucide-react'
import { useThemeStore } from '@/shared/store/themeStore'
import { useAuth } from '@/platform/auth/useAuth'

import { ExperienceControl } from '@/platform/experiences/components/ExperienceControl'

import styles from './Header.module.css'

/**
 * Application top header bar.
 *
 * Contains:
 * - Page title / breadcrumb (future)
 * - Theme toggle (dark/light/system)
 * - User menu (future: notifications, profile)
 */
export function Header() {
  const { theme, setTheme } = useThemeStore()
  const { user } = useAuth()

  const cycleTheme = () => {
    const next = theme === 'dark' ? 'light' : theme === 'light' ? 'system' : 'dark'
    setTheme(next)
  }

  const ThemeIcon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        {/* Future: breadcrumbs, page title */}
      </div>

      <div className={styles.right}>
        <ExperienceControl />

        <button
          className={styles.iconBtn}
          onClick={cycleTheme}
          aria-label={`Current theme: ${theme}. Click to change.`}
          title={`Theme: ${theme}`}
        >
          <ThemeIcon size={16} />
        </button>

        {user && (
          <div className={styles.userChip} title={user.email}>
            <span className={styles.avatar}>
              {user.name.charAt(0).toUpperCase()}
            </span>
            <span className={styles.userName}>{user.name}</span>
          </div>
        )}
      </div>
    </header>
  )
}
